import ApiService from './ApiService'

export async function apiSignIn(data) {
    await ApiService.fetchCSRFToken()
    return ApiService.fetchData({
        url: '/sign-in',
        method: 'post',
        data,
    })
}
export async function apiGetUser(data) {
    return ApiService.fetchData({
        url: '/user',
        method: 'get',
    })
}

export async function apiSignUp(data) {
    return ApiService.fetchData({
        url: '/sign-up',
        method: 'post',
        data,
    })
}

export async function apiSignOut(data) {
    return ApiService.fetchData({
        url: '/sign-out',
        method: 'post',
        data,
    })
}

export async function apiForgotPassword(data) {
    await ApiService.fetchCSRFToken()
    return ApiService.fetchData({
        url: '/forgot-password',
        method: 'post',
        data,
    })
}

export async function apiResetPassword(data) {
    await ApiService.fetchCSRFToken()
    return ApiService.fetchData({
        url: '/reset-password',
        method: 'post',
        data,
    })
}

export async function apiVerifyOtp(data) {
    await ApiService.fetchCSRFToken()
    return ApiService.fetchData({
        url: '/verify-otp',
        method: 'post',
        data,
    })
}

export async function apiResendOtp(data) {
    await ApiService.fetchCSRFToken()
    return ApiService.fetchData({
        url: '/otp/resend',
        method: 'post',
        data,
    })
}
